import { CheckIcon, CloseIcon } from '@svgs'
import React, { FC } from 'react'
import MyModal, { IMyModal } from 'src/components/ui/modal/MyModal'
import { Button } from 'src/components/ui'
import { useTranslation } from 'react-i18next'

interface ISuccessModal extends IMyModal {
  title: string
  text?: string
  buttonText?: string
  onClick?: () => void
}

const SuccessModal: FC<ISuccessModal> = ({
  open,
  handleClose,
  title,
  text,
  buttonText,
  onClick,
}) => {
  const { t } = useTranslation()

  return (
    <MyModal
      showClose={false}
      width="w-[calc(100%_-_2rem)] md:w-[22.125rem]"
      contentClassName="!p-6 !px-8"
      open={open}
      handleClose={handleClose}
    >
      <>
        <button
          onClick={() => handleClose()}
          className="icon-button fill-danger absolute z-20 top-4 right-4 w-4 h-4 hover:fill-danger-strong"
        >
          <CloseIcon />
        </button>
        <div className="flex flex-col gap-4">
          <div className="icon-button w-[7.375rem] h-[7.375rem] bg-brand-strong rounded-full overflow-hidden self-center">
            <div className="icon-button fill-white w-[3.625rem] h-[3.625rem]">
              <CheckIcon />
            </div>
          </div>
          <div className="flex flex-col gap-2 items-center text-center">
            <h2 className="text-lg font-black leading-snug">{title}</h2>
            {text && <div className="text-sm font-normal">{text}</div>}
          </div>
          <Button onClick={onClick ? onClick : handleClose} className="w-full">
            {buttonText ? buttonText : t('understood')}
          </Button>
        </div>
      </>
    </MyModal>
  )
}

export default SuccessModal
